@let responseToCommunication = (responseToCommunication$() | async) || [];
<div>
  @if (responseToCommunication) {
    <div [innerHTML]="responseToCommunication[0].bodyPreview | safe: 'html'" class="mt-space-md innerHTML"></div>
  }
</div>
